export default "<app-payment-detail></app-payment-detail>\n"